var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPickUp = function SvgIconPickUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconPickUp_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.204.715h.013c.097 0 .183.045.238.114l2.279 2.216a.285.285 0 0 1 0 .411.305.305 0 0 1-.423 0L5.517 1.712v5.71c0 .161-.135.292-.3.292a.297.297 0 0 1-.3-.291V1.706l-1.8 1.75a.305.305 0 0 1-.423 0 .285.285 0 0 1 0-.411L5.004.799a.3.3 0 0 1 .2-.084",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.714 8.714h9v1h-9z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconPickUp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.214 7.714h6v-7h-6z"
  })))));
};
export default SvgIconPickUp;